/* SS / Landing (2026-09-30): the #ss-buy anchor.
 *
 * The two paid-traffic pages (page.meta-landing-hand, -head) carry the PDP's purchase area as
 * Impact's featured-product section, whose DOM id is the template's own. Every "Shop" link on the
 * page, the deal bar and the buy dock point at #ss-buy, so the anchor is placed at the top of that
 * section here. Buying itself is the PDP's own flow (ss-shell.js: Buy now posts the native form to
 * checkout, Add to Cart opens the drawer), nothing landing-specific.
 *
 * Phones (2026-10-16): the anchor sits right before the product title, so a tap on the hero
 * button or the buy dock lands on title, price, plan and Buy now, not on the top of the gallery
 * (about three screens above the price). Desktop keeps the section top.
 */
(function () {
  'use strict';

  function anchorBuyZone() {
    if (document.getElementById('ss-buy')) return;
    var zone = document.querySelector('[id$="__buy_product"]');
    if (!zone) return;
    var anchor = document.createElement('span');
    anchor.id = 'ss-buy';
    anchor.setAttribute('aria-hidden', 'true');
    var title = window.matchMedia('(max-width: 749px)').matches ? zone.querySelector('.product-info__title') : null;
    if (title && title.parentNode) {
      anchor.style.display = 'block';
      anchor.style.scrollMarginTop = '64px'; // the stars above the title clear the floating header
      title.parentNode.insertBefore(anchor, title);
    } else {
      zone.insertBefore(anchor, zone.firstChild);
    }
    if (window.location.hash === '#ss-buy') anchor.scrollIntoView({ block: 'start' }); // same target as the taps (Codex r1, PR #358)
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', anchorBuyZone);
  else anchorBuyZone();

  /* Shop taps (2026-10-25, QA D2): landing on the title left Buy now 100 to 330 px below the fold.
   * A tap now scrolls on just far enough to bring Buy now into view, but never past the colour
   * picker, so the finish stays on screen above the plan. Covers every same-page #ss-buy link and
   * the buy dock (ss-buy-dock.liquid calls window.ssScrollToBuy). Without the parts, the old jump. */
  function scrollToBuy() {
    var anchor = document.getElementById('ss-buy');
    if (!anchor) return false;
    var zone = document.querySelector('[id$="__buy_product"]');
    var buy = zone && zone.querySelector('.product-info__buy-buttons');
    var pick = zone && zone.querySelector('.product-info__variant-picker');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!buy || !pick) {
      anchor.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      return true;
    }
    var y = window.scrollY;
    var bar = document.querySelector('.ss-dealbar--inline');
    var clear = bar && getComputedStyle(bar).position === 'fixed' ? Math.max(0, bar.getBoundingClientRect().bottom) : 0;
    var margin = parseFloat(getComputedStyle(anchor).scrollMarginTop) || 0;
    var padTop = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    var base = anchor.getBoundingClientRect().top + y - margin - padTop;
    var need = buy.getBoundingClientRect().bottom + y + 16 - window.innerHeight;
    var cap = pick.getBoundingClientRect().top + y - clear - 12;
    window.scrollTo({ top: Math.max(0, Math.max(base, Math.min(need, cap))), behavior: reduce ? 'auto' : 'smooth' });
    return true;
  }
  window.ssScrollToBuy = scrollToBuy;

  /* A/B arm on the order (2026-10-29, test ml1): every add-to-cart form built on the page carries the
   * arm as the hidden line item property _ss_ab ("ml1-a" / "ml1-b"), so Shopify orders split by arm on
   * every buy path (Buy now, Add to Cart, express). Added at FormData time, so a variant re-render of the
   * form cannot drop it. formdata does not bubble, hence the capture listener. */
  var abRoot = document.documentElement;
  var abArm = abRoot.getAttribute('data-ss-ab') && abRoot.getAttribute('data-ss-arm')
    ? abRoot.getAttribute('data-ss-ab') + '-' + abRoot.getAttribute('data-ss-arm') : '';
  /* ss_buy_view (2026-10-29): the buy block's Buy now was on screen (half of it, 1 s), once per page view.
   * Section reach says the block was entered; this says the visitor could have pressed Buy now. */
  function watchBuyView(tries) {
    if (!('IntersectionObserver' in window) || typeof window.ssTrack !== 'function') return;
    var btn = document.querySelector('[id$="__buy_product"] .ss-buy-now-primary');
    // ss-shell.js builds Buy now after load (setupButtons), so look again for a few seconds
    if (!btn) { if ((tries || 0) < 10) setTimeout(function () { watchBuyView((tries || 0) + 1); }, 500); return; }
    var timer = null;
    var io = new IntersectionObserver(function (entries) {
      // threshold only decides when the observer reports; the ratio says how much is on screen (Codex r1)
      var on = !!entries[0] && entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
      if (on && !timer) {
        timer = setTimeout(function () {
          io.disconnect();
          var bb = btn.closest('[data-ss-product]');
          window.ssTrack('ss_buy_view', { product: bb ? bb.getAttribute('data-ss-product') : undefined });
        }, 1000);
      } else if (!on && timer) { clearTimeout(timer); timer = null; }
    }, { threshold: 0.5 });
    io.observe(btn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watchBuyView(0); });
  else watchBuyView(0);

  if (abArm) {
    document.addEventListener('formdata', function (e) {
      var form = e.target;
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (!e.formData.has('properties[_ss_ab]')) e.formData.append('properties[_ss_ab]', abArm);
    }, true);
  }

  // Capture phase, so the theme's own smooth-scroll for hash links (theme.js) sees defaultPrevented.
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest && e.target.closest('a[href*="#ss-buy"]');
    if (!a || a.hash !== '#ss-buy' || a.pathname !== window.location.pathname || a.search !== window.location.search) return;
    if (!document.getElementById('ss-buy')) return;
    e.preventDefault();
    // Keep the history entry the plain link made, so Back returns to where the tap happened, not off the
    // landing. Pushed before scrolling, so the entry keeps the pre-tap position even with an instant scroll.
    if (window.location.hash !== '#ss-buy' && window.history && history.pushState) history.pushState(null, '', '#ss-buy');
    scrollToBuy();
  }, true);
})();
